import { render } from "./DocumentosUsuarios.vue?vue&type=template&id=2c08cf3a&scoped=true"
import script from "./DocumentosUsuarios.vue?vue&type=script&lang=js"
export * from "./DocumentosUsuarios.vue?vue&type=script&lang=js"

import "./DocumentosUsuarios.vue?vue&type=style&index=0&id=2c08cf3a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c08cf3a"]])

export default __exports__